import { reactive, ref } from 'vue';

export function usePromiseState() {
  const isLoading = ref(false);
  const isLoaded = ref(false);

  async function load<T>(promise: Promise<T>) {
    isLoading.value = true;
    isLoaded.value = false;
    try {
      return await promise;
    } finally {
      isLoading.value = false;
      isLoaded.value = true;
    }
  }

  return reactive({
    isLoading,
    isLoaded,
    load,
  });
}
